<!-- source: https://tailwindcss.com/plus/ui-blocks/application-ui/overlays/modal-dialogs -->

<template>
    <TransitionRoot
        as="template"
        :show="open"
        class="hiorg-vue-app"
    >
        <Dialog
            class="tw:relative tw:z-10"
            @close="open = false"
        >
            <TransitionChild
                as="template"
                enter="tw:ease-out tw:duration-300"
                enter-from="tw:opacity-0"
                enter-to="tw:opacity-100"
                leave="tw:ease-in tw:duration-200"
                leave-from="tw:opacity-100"
                leave-to="tw:opacity-0"
            >
                <div class="tw:fixed tw:inset-0 tw:bg-gray-500/75 tw:transition-opacity" />
            </TransitionChild>

            <div class="tw:fixed tw:inset-0 tw:z-10 tw:w-screen tw:overflow-y-auto">
                <div class="tw:flex tw:min-h-full tw:items-end tw:justify-center tw:p-4 tw:text-center tw:sm:items-center tw:sm:p-0">
                    <TransitionChild
                        as="template"
                        enter="ease-out duration-300"
                        enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        enter-to="opacity-100 translate-y-0 sm:scale-100"
                        leave="ease-in duration-200"
                        leave-from="opacity-100 translate-y-0 sm:scale-100"
                        leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    >
                        <DialogPanel class="tw:relative tw:transform tw:overflow-hidden tw:rounded-lg tw:bg-white tw:px-4 tw:pt-5 tw:pb-4 tw:text-left tw:shadow-xl tw:transition-all tw:sm:my-8 tw:sm:w-full tw:sm:max-w-lg tw:sm:p-6">
                            <div class="tw:sm:flex tw:sm:items-start">
                                <div class="tw:mx-auto tw:flex tw:size-12 tw:shrink-0 tw:items-center tw:justify-center tw:rounded-full tw:bg-red-100 tw:sm:mx-0 tw:sm:size-10">
                                    <ExclamationTriangleIcon
                                        class="tw:size-6 tw:text-red-600"
                                        aria-hidden="true"
                                    />
                                </div>
                                <div class="tw:mt-3 tw:text-center tw:sm:mt-0 tw:sm:ml-4 tw:sm:text-left">
                                    <DialogTitle
                                        as="h3"
                                        class="tw:text-base tw:font-semibold tw:text-gray-900"
                                    >
                                        <span v-html="titel" />
                                    </DialogTitle>
                                    <div class="tw:mt-2">
                                        <p
                                            class="tw:text-sm tw:text-gray-500"
                                            v-html="content"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="tw:mt-5 tw:sm:mt-4 tw:sm:flex tw:sm:flex-row-reverse">
                                <button
                                    type="button"
                                    class="tw:inline-flex tw:w-full tw:justify-center tw:rounded-md tw:bg-hiorg-hellrot-600 tw:px-3 tw:py-2 tw:text-sm tw:font-semibold tw:text-white tw:shadow-xs tw:hover:bg-hiorg-hellrot-500 tw:sm:ml-3 tw:sm:w-auto"
                                    @click="clickFunction"
                                >
                                    {{ buttonText }}
                                </button>
                                <button
                                    ref="cancelButtonRef"
                                    type="button"
                                    class="tw:mt-3 tw:inline-flex tw:w-full tw:justify-center tw:rounded-md tw:bg-white tw:px-3 tw:py-2 tw:text-sm tw:font-semibold tw:text-gray-900 tw:shadow-xs tw:ring-1 tw:ring-gray-300 tw:ring-inset tw:hover:bg-gray-50 tw:sm:mt-0 tw:sm:w-auto"
                                    @click="open = false"
                                >
                                    Abbrechen
                                </button>
                            </div>
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>

<script setup lang="ts">
import {Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot} from "@headlessui/vue";
import {ExclamationTriangleIcon} from "@heroicons/vue/24/outline";
import {computed} from "vue";

const props = defineProps<{
    modelValue: boolean;
    parentFunktion: () => void;
    titel: string;
    content: string;
    buttonText: string;
}>();

const emit = defineEmits<{
    (event: "update:modelValue", value: boolean): void;
}>();

const open = computed({
    get() {
        return props.modelValue;
    },
    set(value: boolean) {
        emit("update:modelValue", value);
    },
});

const clickFunction = (): void => {
    open.value = false;
    props.parentFunktion();
};
</script>
